var _g, _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _clipPath;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHrisConnections = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 121 97"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_3505_37403)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "url(#paint0_linear_3505_37403)",
  d: "M54 9.5v88"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#paint4_linear_3505_37403)",
  d: "M54 9.5v88",
  className: "blue3"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#paint1_linear_3505_37403)",
  d: "M90.5 9.5v22L73 53.5v44"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#paint4_linear_3505_37403)",
  d: "M90.5 9.5v22L73 53.5v44",
  className: "blue3"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#paint2_linear_3505_37403)",
  d: "M66 9.5v88"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#paint4_linear_3505_37403)",
  d: "M66 9.5v88",
  className: "blue3"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#paint3_linear_3505_37403)",
  d: "M60 9.5v88"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#paint4_linear_3505_37403)",
  d: "M60 9.5v88",
  className: "blue3"
}))), /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_3505_37403",
  x1: 53.5,
  x2: 53.5,
  y1: 91.666,
  y2: 11.445,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C2C2D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E0E0EB"
}))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_3505_37403",
  x1: 72.5,
  x2: 72.5,
  y1: 91.666,
  y2: 11.445,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C2C2D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E0E0EB"
}))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_3505_37403",
  x1: 65.5,
  x2: 65.5,
  y1: 91.666,
  y2: 11.445,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C2C2D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E0E0EB"
}))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_3505_37403",
  x1: 59.5,
  x2: 59.5,
  y1: 91.666,
  y2: 11.445,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C2C2D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E0E0EB"
}))), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_3505_37403",
  x1: "0%",
  x2: "0%",
  y1: "0%",
  y2: "100%",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  style: {
    stopColor: "#2f64ed",
    stopOpacity: 0.2
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: "50%",
  style: {
    stopColor: "#2f64ed",
    stopOpacity: 0.5
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  style: {
    stopColor: "#2f64ed",
    stopOpacity: 1
  }
})), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_3505_37403"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M121 0H0v97h121z"
})))));
export { SvgHrisConnections as ReactComponent };
export default "data:image/svg+xml;base64,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";